/** The colored light behind all glass surfaces. */
export function Backdrop() {
  return (
    <div className="backdrop" aria-hidden="true">
      <div className="backdrop__orb backdrop__orb--1" />
      <div className="backdrop__orb backdrop__orb--2" />
      <div className="backdrop__orb backdrop__orb--3" />
      <div className="backdrop__noise" />
    </div>
  );
}
